import ComponentFrequentQuestions from "components/ComponentFrequentQuestions";
import React from "react";
import "./style.scss";

const ContentFrequentQuestions = () => {
    return (
        <div>
            <p className="text-center mb-4  questions">Preguntas Frecuentes</p>
            <ol className="collapsable-list">
                <li>
                    <ComponentFrequentQuestions
                        questions={"1. ¿Cómo puedo canjear?"}
                    >
                        <br />
                        <div className="text-left ">
                            <strong>Cupones para Tienda Física</strong>
                            <br />
                            <strong>Paso 1: </strong>
                            Escanear el código QR o ingresar al sitio web.
                            (cupones.metro.pe o cupones.wong.pe).
                            <br />
                            <strong>Paso 2: </strong>
                            Ingresar con cuenta Wong.pe o Metro.pe, o
                            registrarse.
                            <br />
                            <strong>Paso 3: </strong> Agregar todos los cupones
                            que se va a canjear.
                            <br />
                            <strong>Paso 4: </strong>
                            Generar el código de liberación.
                            <br />
                            <strong>Paso 5: </strong> Presentar el código de
                            liberación en la caja.
                            <br /> <br />
                            <ul>
                                {" "}
                                <strong> Cupones Ecommerce</strong>
                                <br />
                                <li>
                                    <strong>Paso 1: </strong>
                                    Identificar el código del cupón.
                                    <br />
                                </li>
                                <li>
                                    <strong>Paso 2: </strong>
                                    Registrar el código del cupón en el pedido
                                    online.
                                </li>
                            </ul>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "2. ¿Cuántos cupones para tienda Física puedo canjear en un código de liberación?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                El máximo de cupones por código de liberación es
                                15.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "3. ¿Puedo combinar cupones “Para ti” y cupones “masivos”?"
                        }
                    >
                        <br />
                        <p>Si. Se pueden combinar cupones</p>
                        <br />
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "4. ¿Qué debo hacer en caso olvide mi contraseña?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                Para recuperar tu clave secreta deberás ingresar
                                al link ,“¿Olvidaste tu clave?“ que aparece
                                debajo de los recuadros asignados para el correo
                                y la clave.
                                <br />
                                <br />
                                El sistema pedirá que ingreses tu correo, en el
                                cual te llegara una clave de acceso para poder
                                cambiar tu contraseña.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "5. ¿Puedo combinar cupones de tienda Física con Ecommerce?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>No. La dinámica de canje es diferente.</p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "6. ¿Puedo tener dos códigos de liberación en un mismo día?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                Si. Pero si el primero aún no ha sido canjeado,
                                será sustituido por el ultimo código de
                                liberación.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "7. ¿Otra persona puede canjear mi código de liberación si son cupones “Masivos sin Bonus”?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                Si, los masivos sin bonus son cupones que se
                                puede canjear sin presentar tarjeta bonus.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "8. ¿Puede otra persona canjear mis cupones “masivos con bonus” o “para ti”?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                No, esos cupones solo se canjean presentando su
                                tarjeta bonus.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "9. ¿En qué momento de la compra puedo dar mi código de liberación?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                El código de liberación se puede dar antes,
                                durante y al final de la compra.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={"10. ¿Que son los cupones “Para ti”?"}
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                Son cupones especialmente para ti como cliente
                                de acuerdo con tu perfil de compra.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "11. ¿Puedo crear el código de liberación minutos antes de realizar la compra?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                Si, recuerda que tu código de liberación tiene
                                un plazo de 24h como máximo y depende de la
                                vigencia de los cupones seleccionados.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "12. ¿Cuántas veces puedo utilizar mi código de liberación?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                El código de liberación solo se puede utilizar
                                una sola vez en la caja, si excedió el tiempo de
                                vigencia. Deberá generar un nuevo código de
                                liberación.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
                <li>
                    <ComponentFrequentQuestions
                        questions={
                            "13. Si en mi código de liberación tengo un cupón con un producto que no llegue a comprar. ¿Perderé tambien ese cupón en la web de cupones?"
                        }
                    >
                        <br />
                        <div className="text-left">
                            <p>
                                No. Solo desaparecerán de la web de cupones
                                todos aquellos que se utilicen en la compra.
                            </p>
                        </div>
                    </ComponentFrequentQuestions>
                    <br />
                </li>
            </ol>
        </div>
    );
};

export default ContentFrequentQuestions;
